<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "App",
    components: {},
};
</script>

<style>
* {
    padding: 0;
    margin: 0;
}

body {
    min-width: 1100px;
}

img {
    display: block;
}
</style>
